import common from './zh-CN/common';
import metric from './zh-CN/metric';
import topcharts from './zh-CN/topcharts';
/** 表格等文本提示 */
import infoDoc from './zh-CN/infoDoc';
// 下载页面
import downloadPage from './zh-CN/downloadPage';
// compare功能
import Compare from './zh-CN/compare';
// 相对时间筛选器
import rangeMonthPicker from './zh-CN/rangeMonthPicker';
// 公司榜单
import company from './zh-CN/company';
// 指标
import metricSubValue from './zh-CN/metricSubValue';
// store rank
import storeRank from './zh-CN/storeRank';
// 游戏推荐
import trending from './zh-CN/trending';
// Sum、Avg、Max 指标组合 中英文翻译
import calcMetrics from './zh-CN/calcMetrics';
// Global View
import globalView from './zh-CN/globalView';
// 分页器
import pagination from './zh-CN/pagination';
// Reports 界面
import reports from './zh-CN/reports';
// mobile Device
import mobileDevice from './zh-CN/mobileDevice';
// genre profile
import genreProfile from './zh-CN/genreProfile';
// source & metrics
import sourceMetrics from './zh-CN/sourceMetrics';
// mobile Device
import marketProfile from './zh-CN/marketProfile';
// streaming榜单
import streaming from './zh-CN/streaming';
// 筛选器保存
import filterSave from './zh-CN/filterSave';
// pcConsoleBenchmark页面
import pcConsoleBenchmark from './zh-CN/pcConsoleBenchmark';
// mobile game Benchmark页面
import mobileGameBenchmark from './zh-CN/mobileGameBenchmark';
// Metrics Creditability
import metricsCreditability from './zh-CN/metricsCreditability';
// 新手引导
import userGuide from './zh-CN/guide';
import overlapAnalysis from './zh-CN/overlapAnalysis';
// 文本不需要翻译，用于避免报错
import text from './zh-CN/text';
// PC&Console 宽表 metric 修改后，筛选项变动弹窗
import filterTipModal from './zh-CN/filterTipModal';
// 无需翻译，但不带key会报错
import noTranslate from './zh-CN/noTranslate';
// 复用页面
import reusePages from './zh-CN/reusePages';
// CasualGenreProfile页面
import CasualGenreProfile from './zh-CN/CasualGenreProfile';
// mobile 游戏详情页 countries 标签页卡片标题
import mobileDetailCountriesCardTitle from './zh-CN/mobileDetailCountriesCardTitle';

export default {
  ...common,
  ...metric,
  ...topcharts,
  ...infoDoc,
  ...downloadPage,
  ...Compare,
  ...rangeMonthPicker,
  ...company,
  ...metricSubValue,
  ...storeRank,
  ...trending,
  ...calcMetrics,
  ...globalView,
  ...pagination,
  ...reports,
  ...mobileDevice,
  ...genreProfile,
  ...sourceMetrics,
  ...marketProfile,
  ...streaming,
  ...filterSave,
  ...pcConsoleBenchmark,
  ...mobileGameBenchmark,
  ...metricsCreditability,
  ...userGuide,
  ...overlapAnalysis,
  ...text,
  ...filterTipModal,
  ...noTranslate,
  ...reusePages,
  ...CasualGenreProfile,
  ...mobileDetailCountriesCardTitle,
};
